import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibGoogle,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibCcStripe,
  cibCcPaypal,
  cibCcApplePay,
  cibCcAmex,
} from '@coreui/icons'
import { cifUs, cifBr, cifIn, cifFr, cifEs, cifPl } from '@coreui/icons'
import {
  cilArrowBottom,
  cilArrowRight,
  cilArrowTop,
  cilBan,
  cilBasket,
  cilBell,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronTop,
  cilCheckCircle,
  cilCode,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMediaPlay,
  cilMenu,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilXCircle,
  // new
  cilCommand,
  cilHome,
  cilInstitution,
  cilAccountLogout,
  cilClock,
  cilWarning,
  cilSearch,
  cilInfo,
  cilJustifyLeft,
  cilFlower,
  cilPlant,
  cilCaretRight,
  cilMap,
  cilSpreadsheet,
  cilPrint,
  cilSave,
  cilCaretLeft,
  cilPlus,
  cilMinus,
  cilCircle,
  cilShortText,
  cilCalendarCheck,
  cilChevronCircleRightAlt,
  cilPhone,
  cilTag,
  cilBarcode,
  cilBirthdayCake,
  cilCreditCard,
  cilWc,
  cilSpa,
  cilBank,
  cilDescription,
  cilImage,
  cilSitemap,
  cilContact,
  cilEducation,
  cilMoney,
  cilBadge,
  cilVoiceOverRecord,
  cilLibrary,
  cilGamepad,
  cilCat,
  cilCommentBubble,
  cilNoteAdd,
  cilChatBubble,
  cilFace,
  cilSpeak,
  cilSmile,
  cilTouchApp,
  cilTruck,
  cilUserPlus,
  cilGraph,
  cilIndustry,
  cilSchool,
  cilCheckAlt,
  cilTrash,
  cilFilter,
  cilQrCode,
  cilX,
  cilMobile,
  cilLoopCircular,
  cilBlur
} from '@coreui/icons'

export const iconsSet = Object.assign(
  {
    // new
    cilCommand,
    cilHome,
    cilInstitution,
    cilAccountLogout,
    cilClock,
    cilWarning,
    cilSearch,
    cilInfo,
    cilJustifyLeft,
    cilFlower,
    cilPlant,
    cilCaretRight,
    cilMap,
    cilSpreadsheet,
    cilPrint,
    cilSave,
    cilCaretLeft,
    cilPlus,
    cilMinus,
    cilCircle,
    cilShortText,
    cilCalendarCheck,
    cilChevronCircleRightAlt,
    cilPhone,
    cilTag,
    cilBarcode,
    cilBirthdayCake,
    cilCreditCard,
    cilWc,
    cilSpa,
    cilBank,
    cilDescription,
    cilImage,
    cilSitemap,
    cilContact,
    cilEducation,
    cilMoney,
    cilBadge,
    cilVoiceOverRecord,
    cilLibrary,
    cilGamepad,
    cilCat,
    cilCommentBubble,
    cilNoteAdd,
    cilChatBubble,
    cilFace,
    cilSpeak,
    cilSmile,
    cilTouchApp,
    cilTruck,
    cilUserPlus,
    cilGraph,
    cilIndustry,
    cilSchool,
    cilCheckAlt,
    cilTrash,
    cilFilter,
    cilQrCode,
    cilX,
    cilMobile,
    cilLoopCircular,
    cilBlur
  },
  {
    cilArrowBottom,
    cilArrowRight,
    cilArrowTop,
    cilBan,
    cilBasket,
    cilBell,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChartPie,
    cilCheck,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCode,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMediaPlay,
    cilMenu,
    cilMoon,
    cilNotes,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilXCircle,
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl,
  },
  {
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibGoogle,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibCcStripe,
    cibCcPaypal,
    cibCcApplePay,
    cibCcAmex,
  },
)
